import Service from "../Service";
import Vue from "vue";

const resource = "Substances/";

export default {

    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
    save(obj, requestID) {
        console.log(obj)
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID },
        });
    },
    list(requestID, typeSubstances = null) {
        const params = {
            requestID: requestID,
            TypeSubstances: (typeSubstances !== null && typeSubstances !== undefined && typeSubstances !== "") ? typeSubstances : null,
        };
        return Service.post(resource + "list", null, {
            params: params,
        });
    },
    getUrlList() {
        return Vue.prototype.$http.defaults.baseURL + "/Substances/list";
    },
    GetUrllistActiveSubstances() {
        return Vue.prototype.$http.defaults.baseURL + "/Substances/list";
    },
};